<template>
  <div class="page-main">
    <el-header style="height:56px;padding:0;background:#ffffff;">
      <div class="flex space alcenter plr20" style="height:60px;">
        <!-- <div class="ft16 text-main">{{$route.meta.title}}</div> -->
        <img src="@/assets/images/logo.png" class="companyLogo" alt="">
        <div class="flex alcenter">
          <div class="ml20 flex alcenter">
            <div class="ml10">
              <!-- <el-dropdown> -->
              <div class="text-main ft14 flex" style="opacity:0.8;">
                <img class="admin-face" src="https://smhs-1258084849.cos.ap-nanjing.myqcloud.com/smhsw/image/face.png"/>
                <p style="line-height: 32px;margin-right:10px;">
                  {{ $store.getters.info.username }}
                </p>
                <p style="line-height: 32px;color:#D5D9E0;">|</p>
                <p class="exit" @click="logout">退出
                  <i style="color:#000;font-size:18px" class="el-icon-switch-button el-icon--right"></i>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-header>
    <el-container>
      <el-aside width="240px" style="height:calc(100vh - 56px);background:#273043;">
        <div class="menu-main">
          <el-menu
              :default-active="$route.name"
              class="el-menu-vertical-demo"
              background-color="#273043"
              text-color="#9298aa"
              active-text-color="#FEFFFE"
          >
            <div v-for="item in menus" :key="item.name">
              <el-menu-item
                  v-if="!item.child ||item.child.length <= 0"
                  :index="item.name"
                  @click="toPth(item.link)"
              >
                <i class="iconfont ft18 mr5 " :class="item.icon"></i>
                <span style="user-select: none" slot="title">{{ item.title }}</span>
              </el-menu-item>
              <el-submenu v-else :index="item.name">
                <template slot="title">
                  <i style="color: #9298aa" class="iconfont mr10 ft18 " :class="item.icon"></i>
                  <span style="user-select: none">{{ item.title }}</span>
                </template>
                <el-menu-item
                    class="ml10"
                    :key="key"
                    v-for="(val,key) in item.child"
                    @click="toPth(val.link)"
                    :index="val.name"
                >{{ val.title }}
                </el-menu-item>
              </el-submenu>
            </div>
          </el-menu>
        </div>
      </el-aside>
      <el-main style="min-width: 1200px;">
        <tags-view />
        <div style="overflow-y: auto;height: calc(100vh - 136px);">
          <router-view></router-view>
        </div>
      </el-main>

    </el-container>

  </div>
</template>

<script>
import {menus} from "../../router/menus";
import TagsView from "../../components/TagsView/index.vue";

export default {
  components: {
    TagsView
  },
  created() {
    this.getMenus();
    // this.$socket.emit("Register", {token: this.$store.getters.token});
  },
  data() {
    return {
      search: "",
      menus: null,
      showName: "",
      title: "",
    };
  },
  watch: {},

  methods: {
    getMenus() {
      var act_menus = [];
      let code = this.$store.getters.info.auth_code;
      menus.forEach(value => {
        if (value.code == "*" || code.indexOf(value.code) != -1) {
          act_menus.push(value);
        }
      })
      this.menus = act_menus;
    },
    logout() {
      this.$confirm("此操作将登出后台, 是否继续?", "提示", {
        confirmButtonText: "登出",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            this.$store.dispatch("admin/logout").then(() => {
              this.$router.push({
                path:'/'
              })
            });
          })
          .catch(() => {
          });
    },
    toPth(path) {
      if (path != this.$route.fullPath) {
        this.$router.push(path);
      }
    },
  },
};
</script>
<style>
.el-main {
  padding: 0 10px 24px 10px !important;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  background-color: red;
  overflow-x: hidden;
  border: none;
}

.el-menu-item.is-active {
  background-color: #007EFF !important;
}

.page-main {
  height: 100vh;
  width: 100%;

}

.companyLogo {
  width: 88px;
  height: 46px;
}

.logo {
  width: 100%;
  height: 70px;
}

.exit {
  line-height: 32px;
  font-size: 14px;
  color: #333;
  margin-left: 10px;
  margin-right: 10px;
  cursor: pointer
}

.menu-main {
  height: calc(100vh - 100px);
  overflow-y: scroll;
  margin-top: 28px;
}

.menu-main::-webkit-scrollbar {
  width: 0px;
}

.menu-main::-webkit-scrollbar-thumb {
  width: 0px;
}

.page-main-content {
  height: calc(100vh - 56px);
  overflow-y: scroll;
  padding: 0;
  margin: 0;
}

.page-main-content::-webkit-scrollbar {
  width: 0px;
}

.page-main-content::-webkit-scrollbar-thumb {
  width: 0px;
}

.admin-face {
  width: 30px;
  height: 30px;
  margin-top: 0;
  margin-right: 10px;
}
</style>
